import { render, staticRenderFns } from "./NewProductEntry.vue?vue&type=template&id=445ce6a0&scoped=true"
import script from "./NewProductEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProductEntry.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ce6a0",
  null
  
)

export default component.exports